/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-07-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card, TextContainer, TextStyle, Heading, Badge, Button } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Xmas22Constants } from 'src/constants/campaigns';
import { allowToShowSpecialDiscount } from 'src/helpers/dashboard-helper';
import { routes } from 'src/routes';
import history from 'src/routes/history';

type Props = {
  tenantApp: Object,
  subscription: Object
};

type ComposedProps = Props & WithI18nProps;
class SubscriptionStatus extends Component<ComposedProps> {
  // Render content status
  renderContentStatus() {
    let { tenantApp = {}, subscription = {}, i18n } = this.props;

    // Get subscription status
    let { status, productsPlan, dayLeft = 0, planLabel, planName } = subscription;

    // Check addon feature
    const { hasExtraFee = false, appliedDiscountCode = {} } = tenantApp;
    const chargedDiscountPercent = _.get(appliedDiscountCode, 'percent', 0) * 100;
    const [todayDateString] = new Date().toISOString().split('T');
    const today = new Date(todayDateString).getTime() / 1000;
    // Expired date of discount duration
    const expiredAt = _.get(appliedDiscountCode, 'expiredAt', 0);

    const isAllowSpecialDiscount = allowToShowSpecialDiscount(
      tenantApp,
      Xmas22Constants.startDate,
      Xmas22Constants.endDate
    );
    const contentStatus = {
      expired: (
        <React.Fragment>
          <div className="subscribe_badge">
            <Badge status="attention">{i18n.translate('AdminHTML.Dashboard.Common.trial')}</Badge>
            {hasExtraFee && (
              <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
            )}
          </div>
          <div className="subscribe__bottom">
            {isAllowSpecialDiscount ? (
              <p>
                {i18n.translate(
                  'AdminHTML.Dashboard.SubscriptionStatus.expired_Paragraph_BFCM2021',
                  {
                    discount: (
                      <span style={{ fontWeight: 600 }}>
                        <TextStyle variation="negative">
                          {i18n.translate(
                            `AdminHTML.Dashboard.SubscriptionStatus.BFCM2021_Discount_Percent`
                          )}
                        </TextStyle>
                      </span>
                    ),
                    duration: (
                      <TextStyle variation="strong">
                        {i18n.translate(`AdminHTML.Dashboard.SubscriptionStatus.BFCM2021_Duration`)}
                      </TextStyle>
                    )
                  }
                )}
              </p>
            ) : (
              <p>{i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.expired_Paragraph')}</p>
            )}
            <Button
              primary
              size="slim"
              onClick={() => this.goToSubscriptionPage(isAllowSpecialDiscount)}>
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText1')}
            </Button>
            <p className="subscribe-money-back">
              {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
            </p>
          </div>
        </React.Fragment>
      ),

      regularExpired: (
        <React.Fragment>
          <div className="subscribe_dangerous">
            <Badge status="warning">
              {i18n.translate('AdminHTML.Subscription.PlanStatus.status_Expired')}
            </Badge>
            {hasExtraFee && (
              <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
            )}
          </div>
          <div className="subscribe__bottom">
            <p>
              {i18n.translate('AdminHTML.Subscription.PlanStatus.regularPlanExpired_modal_content')}
            </p>

            <Button primary size="slim" onClick={() => this.goToSubscriptionPage()}>
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText1')}
            </Button>
            <p className="subscribe-money-back">
              {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
            </p>
          </div>
        </React.Fragment>
      ),
      trial: (
        <React.Fragment>
          <div className="subscribe_badge">
            <Badge status="attention">{i18n.translate('AdminHTML.Dashboard.Common.trial')}</Badge>
            {hasExtraFee && (
              <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
            )}
          </div>
          <div className="subscribe__bottom">
            {isAllowSpecialDiscount ? (
              <p>
                {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.trial_Paragraph_BFCM2021', {
                  nt_duration_in_day: (
                    <TextStyle variation="strong">
                      {i18n.translate(`AdminHTML.Common.Duration.dayV2`, {
                        count: dayLeft,
                        nt_number: i18n.formatNumber(dayLeft)
                      })}
                    </TextStyle>
                  ),
                  discount: (
                    <span style={{ fontWeight: 600 }}>
                      <TextStyle variation="negative">
                        {i18n.translate(
                          `AdminHTML.Dashboard.SubscriptionStatus.BFCM2021_Discount_Percent`
                        )}
                      </TextStyle>
                    </span>
                  ),
                  duration: (
                    <TextStyle variation="strong">
                      {i18n.translate(`AdminHTML.Dashboard.SubscriptionStatus.BFCM2021_Duration`)}
                    </TextStyle>
                  )
                })}
              </p>
            ) : (
              <p>
                {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.trial_Paragraph', {
                  nt_duration_in_day: (
                    <TextStyle variation="strong">
                      {i18n.translate(`AdminHTML.Common.Duration.day`, {
                        count: dayLeft,
                        nt_number: i18n.formatNumber(dayLeft)
                      })}
                    </TextStyle>
                  )
                })}
              </p>
            )}

            <Button
              primary
              size="slim"
              onClick={() => this.goToSubscriptionPage(isAllowSpecialDiscount)}>
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText1')}
            </Button>
            <p className="subscribe-money-back">
              {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
            </p>
          </div>
        </React.Fragment>
      ),

      expiredSoon: (
        <React.Fragment>
          <div className="subscribe_badge">
            <Badge status="warning">
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.expiredSoon_Badge')}
            </Badge>
            {hasExtraFee && (
              <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
            )}
          </div>
          <div className="subscribe__bottom">
            <p>
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.expiredSoon_Paragraph', {
                nt_duration_in_day: (
                  <TextStyle variation="strong">
                    {i18n.translate(`AdminHTML.Common.Duration.day`, {
                      count: dayLeft,
                      nt_number: i18n.formatNumber(dayLeft)
                    })}
                  </TextStyle>
                )
              })}
            </p>
            <Button primary size="slim" onClick={() => this.goToSubscriptionPage()}>
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText1')}
            </Button>
            <p className="subscribe-money-back">
              {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
            </p>
          </div>
        </React.Fragment>
      ),

      regularExpiredSoon: this.renderRegularPlanExpiredSoon(hasExtraFee),

      subscribed: (
        <React.Fragment>
          <div className="subscribe_badge">
            <Badge status="success">{planLabel ? i18n.translate(planLabel) : status}</Badge>
            {hasExtraFee && (
              <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
            )}
            {/* Hide Badge discount percent when expired */}
            {chargedDiscountPercent && (expiredAt > today || !expiredAt) ? (
              <Badge status="info">
                {i18n.translate('AdminHTML.Subscription.PlanStatus.discountPercentBadge', {
                  nt_percent: chargedDiscountPercent
                })}
              </Badge>
            ) : (
              ''
            )}
          </div>
          <div className="subscribe__bottom">
            <p className="success">
              {planName === 'offer0_1'
                ? i18n.translate(
                    'AdminHTML.Dashboard.SubscriptionStatus.subscribed_PasswordProtectedOffer_Paragraph'
                  )
                : i18n.translate(
                    'AdminHTML.Dashboard.SubscriptionStatus.subscribed_NotAllowedBFCM20_Paragraph',
                    {
                      nt_number: productsPlan
                    }
                  )}
            </p>
            <Button size="slim" onClick={() => this.goToSubscriptionPage()}>
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText3')}
            </Button>
            <p className="subscribe-money-back">
              {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
            </p>
          </div>
        </React.Fragment>
      ),

      exceeded: (
        <React.Fragment>
          <div className="subscribe_badge">
            <Badge status="attention">{planLabel ? i18n.translate(planLabel) : ''}</Badge>
            {hasExtraFee && (
              <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
            )}
          </div>
          <div className="subscribe__bottom">
            <p>
              {i18n.translate(
                'AdminHTML.Dashboard.Common.pleaseUpgradeTheCurrentExceededPlanToAHigherOneToPreventAnyInterruptions'
              )}
            </p>
            <Button size="slim" onClick={() => this.goToSubscriptionPage()}>
              <span className="upgrade">
                {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText4')}
              </span>
            </Button>
            <p className="subscribe-money-back">
              {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
            </p>
          </div>
        </React.Fragment>
      ),

      exceededWithNotification: (
        <React.Fragment>
          <div className="subscribe_badge">
            <Badge status="attention">{planLabel ? i18n.translate(planLabel) : ''}</Badge>
            {hasExtraFee && (
              <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
            )}
          </div>
          <div className="subscribe__bottom">
            <p>
              {i18n.translate(
                'AdminHTML.Dashboard.Common.pleaseUpgradeTheCurrentExceededPlanToAHigherOneToPreventAnyInterruptions'
              )}
            </p>
            <Button size="slim" onClick={() => this.goToSubscriptionPage()}>
              <span className="upgrade">
                {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText4')}
              </span>
            </Button>
            <p className="subscribe-money-back">
              {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
            </p>
          </div>
        </React.Fragment>
      ),
      specialDiscount2021ExpiredSoon: this.renderSpecialDiscountCodeExpiredSoon(hasExtraFee),
      specialDiscountExpiredSoon: this.renderSpecialDiscountCodeExpiredSoon(hasExtraFee),
      specialDiscountExpired: this.renderSpecialDiscountCodeExpired(hasExtraFee),
      passwordProtectedOfferExpiredSoon: this.renderPasswordProtectedOfferExpiredSoon(hasExtraFee),
      passwordProtectedOfferExpired: this.renderPasswordProtectedOfferExpired(hasExtraFee)
    };

    return contentStatus[status];
  }

  render() {
    const { i18n } = this.props;

    return (
      <div className="BC-CalloutCard-Subscription__Dashboard">
        <Card sectioned>
          <div className="subscribeBox">
            <TextContainer>
              <Heading>
                {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.cardHeading')}
              </Heading>
              {this.renderContentStatus()}
            </TextContainer>
          </div>
        </Card>
      </div>
    );
  }

  renderSpecialDiscountCodeExpiredSoon = hasExtraFee => {
    const { i18n, subscription = {} } = this.props;
    let { dayLeft = 0 } = subscription;

    // Uppercase first character (fix for german text, since duration appears at the beginning of string)
    let duration = i18n.translate(`AdminHTML.Common.Duration.dayV2`, {
      count: dayLeft,
      nt_number: i18n.formatNumber(dayLeft)
    });
    duration = _.upperFirst(duration);

    return (
      <React.Fragment>
        <div className="subscribe_warning">
          <Badge status="warning">
            {i18n.translate(
              'AdminHTML.Dashboard.SubscriptionStatus.specialDiscountExpiredSoon_Badge'
            )}
          </Badge>
          {hasExtraFee && (
            <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
          )}
        </div>
        <div className="subscribe__bottom">
          <p>
            {i18n.translate(
              'AdminHTML.Dashboard.SubscriptionStatus.specialDiscountExpiredSoon_Paragraph',
              {
                nt_duration_in_day: <TextStyle variation="strong">{duration}</TextStyle>,
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate(`AdminHTML.Common.Subscription.reSubscribe`)}
                  </TextStyle>
                )
              }
            )}
          </p>
          <Button size="slim" primary onClick={() => this.goToSubscriptionPage()}>
            <span className="upgrade">
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText1')}
            </span>
          </Button>
          <p className="subscribe-money-back">
            {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
          </p>
        </div>
      </React.Fragment>
    );
  };

  renderRegularPlanExpiredSoon = hasExtraFee => {
    const { i18n, subscription = {} } = this.props;
    let { dayLeft = 0 } = subscription;

    // Uppercase first character (fix for german text, since duration appears at the beginning of string)
    let duration = i18n.translate(`AdminHTML.Common.Duration.day`, {
      count: dayLeft,
      nt_number: i18n.formatNumber(dayLeft)
    });
    duration = _.upperFirst(duration);

    return (
      <React.Fragment>
        <div className="subscribe_warning">
          <Badge status="warning">
            {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.expiredSoon_Badge')}
          </Badge>
          {hasExtraFee && (
            <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
          )}
        </div>
        <div className="subscribe__bottom">
          <p>
            {i18n.translate(
              'AdminHTML.Dashboard.SubscriptionStatus.regularPlanExpireSoonParagraph',
              {
                nt_duration_in_day: <TextStyle variation="strong">{duration}</TextStyle>,
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate(`AdminHTML.Common.Subscription.subscribe`)}
                  </TextStyle>
                )
              }
            )}
          </p>
          <Button size="slim" primary onClick={() => this.goToSubscriptionPage()}>
            <span className="upgrade">
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText1')}
            </span>
          </Button>
          <p className="subscribe-money-back">
            {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
          </p>
        </div>
      </React.Fragment>
    );
  };

  renderSpecialDiscountCodeExpired = hasExtraFee => {
    const { i18n } = this.props;

    return (
      <React.Fragment>
        <div className="subscribe_badge">
          <Badge status="warning">
            {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.specialDiscountExpired_Badge')}
          </Badge>
          {hasExtraFee && (
            <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
          )}
        </div>
        <div className="subscribe__bottom">
          <p>
            {i18n.translate(
              'AdminHTML.Dashboard.SubscriptionStatus.specialDiscountExpired_Paragraph',
              {
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate(`AdminHTML.Common.Subscription.reSubscribe`)}
                  </TextStyle>
                )
              }
            )}
          </p>
          <Button size="slim" primary onClick={() => this.goToSubscriptionPage()}>
            <span className="upgrade">
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText1')}
            </span>
          </Button>
          <p className="subscribe-money-back">
            {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
          </p>
        </div>
      </React.Fragment>
    );
  };

  renderPasswordProtectedOfferExpiredSoon = hasExtraFee => {
    const { i18n, subscription = {} } = this.props;
    let { dayLeft = 0 } = subscription;

    // Uppercase first character (fix for german text, since duration appears at the beginning of string)
    let duration = i18n.translate(`AdminHTML.Common.Duration.dayV2`, {
      count: dayLeft,
      nt_number: i18n.formatNumber(dayLeft)
    });
    duration = _.upperFirst(duration);

    return (
      <React.Fragment>
        <div className="subscribe_badge">
          <Badge status="attention">
            {i18n.translate(
              'AdminHTML.Dashboard.SubscriptionStatus.passwordProtectedOfferExpiredSoon_Badge'
            )}
          </Badge>
          {hasExtraFee && (
            <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
          )}
        </div>
        <div className="subscribe__bottom">
          <p>
            {i18n.translate(
              'AdminHTML.Dashboard.SubscriptionStatus.passwordProtectedOfferExpiredSoon_Paragraph',
              {
                nt_duration_in_day: <TextStyle variation="strong">{duration}</TextStyle>,
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate(`AdminHTML.Common.Subscription.reSubscribe`)}
                  </TextStyle>
                )
              }
            )}
          </p>
          <Button size="slim" primary onClick={() => this.goToSubscriptionPage()}>
            <span className="upgrade">
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText1')}
            </span>
          </Button>
          <p className="subscribe-money-back">
            {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
          </p>
        </div>
      </React.Fragment>
    );
  };

  renderPasswordProtectedOfferExpired = hasExtraFee => {
    const { i18n } = this.props;

    return (
      <React.Fragment>
        <div className="subscribe_badge">
          <Badge status="warning">
            {i18n.translate(
              'AdminHTML.Dashboard.SubscriptionStatus.passwordProtectedOfferExpired_Badge'
            )}
          </Badge>
          {hasExtraFee && (
            <Badge status="critical">{i18n.translate('AdminHTML.Dashboard.Common.addon')}</Badge>
          )}
        </div>
        <div className="subscribe__bottom">
          <p>
            {i18n.translate(
              'AdminHTML.Dashboard.SubscriptionStatus.passwordProtectedOfferExpired_Paragraph',
              {
                t1: (
                  <TextStyle variation="strong">
                    {i18n.translate(`AdminHTML.Common.Subscription.reSubscribe`)}
                  </TextStyle>
                )
              }
            )}
          </p>
          <Button size="slim" primary onClick={() => this.goToSubscriptionPage()}>
            <span className="upgrade">
              {i18n.translate('AdminHTML.Dashboard.SubscriptionStatus.buttonText1')}
            </span>
          </Button>
          <p className="subscribe-money-back">
            {i18n.translate('AdminHTML.Common.Subscription.moneyBackGuarantee')}
          </p>
        </div>
      </React.Fragment>
    );
  };

  // Go to subscription page
  goToSubscriptionPage = isAllowSpecialDiscount => {
    if (isAllowSpecialDiscount) {
      history.push(
        `${routes.subscription.discount()}?&itm_source=inapp&itm_medium=select-plan&itm_campaign=xmas22`
      );
    } else {
      history.push(routes.subscription.plan());
    }
  };
}

const mapStateToProps = (state, props) => {
  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  return {
    tenantApp,
    subscription: _.get(state.oauth, 'subscription', {})
  };
};

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(SubscriptionStatus));
